export default {
  filters: {
    $_percentFilter_calcPercentCap(value) {
      if (value != null) {
        if (value > 0) {
          value = value * 100
          value = value > 100 ? 100 : value
          return parseInt(value) + '%'
        }
      }
      return '-'
    },
    $_percentFilter_calcPercentNoCap(value) {
      if (value != null) {
        // if (value > 0) {
        value = value * 100
        return parseInt(value) + '%'
        // }
      }
      return '-'
    }
  }
}
